import React from 'react';
import { Layers3, Sparkles } from 'lucide-react';

const CustomStaffModule = ({ module }) => (
  <div className="space-y-5" data-testid={`custom-staff-module-${module.key}`}>
    <div className="rounded-[1.75rem] bg-white p-6 shadow-sm">
      <div className="flex items-start gap-4">
        <div className="flex h-14 w-14 items-center justify-center rounded-3xl bg-[#0A2540]/6">
          <Layers3 className="h-6 w-6 text-[#0A2540]" />
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sky-600">Custom module</p>
          <h2 className="mt-2 text-3xl font-semibold text-[#0A2540]" style={{ fontFamily: 'Outfit, sans-serif' }}>{module.label}</h2>
          <p className="mt-2 max-w-2xl text-sm text-slate-500">{module.description || 'This custom staff module was added by admin and is now available based on permissions.'}</p>
        </div>
      </div>
    </div>

    <div className="rounded-[1.75rem] bg-[#0A2540] p-6 text-white shadow-sm">
      <div className="flex items-center gap-3">
        <Sparkles className="h-5 w-5 text-sky-300" />
        <h3 className="text-lg font-semibold">Module enabled successfully</h3>
      </div>
      <p className="mt-3 text-sm text-slate-200">
        Staff with permission can now see this module in the sidebar. If you want, I can build a dedicated workflow for this custom module next.
      </p>
    </div>
  </div>
);

export default CustomStaffModule;